export const supportedOAuthTypes = {
  Okta: "Okta",
  Auth0: "Auth0",
  Other: "Other",
};
